export default __webpack_public_path__ + "img/emdrhslQ.13f15665.svg";